import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'estadoComercio'
})
export class EstadoComercioPipe implements PipeTransform {

  transform(value: string, ...args: string[]): string {
    return value ? 'Activo' : 'Desactivado';
  }
}
